"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApModal = void 0;
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var react_dom_1 = require("react-dom");
var theme_1 = require("../../utils/theme");
var ApButtons_1 = require("../ApButtons");
var styles_1 = require("./styles");
exports.ApModal = function (_a) {
    var _b, _c;
    var trigger = _a.trigger, header = _a.header, footer = _a.footer, isFluid = _a.isFluid, isDismissible = _a.isDismissible, isOpen = _a.isOpen, hasClosed = _a.hasClosed, className = _a.className, children = _a.children, zIndex = _a.zIndex;
    var _d = __read(react_1.useState(!!isOpen), 2), stateIsOpen = _d[0], setIsOpen = _d[1];
    var _e = __read(react_1.useState((_c = (_b = document === null || document === void 0 ? void 0 : document.body) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.overflow), 1), prevOverflow = _e[0];
    react_1.useEffect(function () {
        if (isOpen !== undefined && isOpen !== stateIsOpen) {
            setIsOpen(isOpen);
        }
    }, [isOpen]);
    react_1.useEffect(function () {
        var _a, _b;
        (_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty('overflow', stateIsOpen ? 'hidden' : prevOverflow);
        return function () {
            var _a, _b;
            (_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty('overflow', prevOverflow);
        };
    }, [stateIsOpen]);
    var handleOpen = function () {
        setIsOpen(true);
    };
    var handleClose = function () {
        setIsOpen(false);
        if (hasClosed) {
            hasClosed();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(styles_1.StyledModalTrigger, null, trigger &&
            trigger({
                handleOpen: function () { return handleOpen(); },
            })),
        stateIsOpen &&
            react_dom_1.createPortal(React.createElement(React.Fragment, null,
                React.createElement(styles_1.StyledModal, { zIndex: zIndex, className: "ap-modal " + (className ? className : '') },
                    React.createElement(styles_1.StyledModalLightbox, { className: "ap-modal-lightbox", onClick: function () { return handleClose(); } }),
                    React.createElement(styles_1.StyledModalWrapper, { className: "ap-modal-wrapper" },
                        React.createElement(styles_1.StyledModalContent, { className: "ap-modal-content", isFluid: isFluid },
                            header && (React.createElement(styles_1.StyledModalHeader, { className: "ap-modal-header" },
                                React.createElement("h4", null, header),
                                isDismissible && (React.createElement(ApButtons_1.ApButtonIcon, { iconName: "baseline_close", onClick: function () { return handleClose(); } })))),
                            React.createElement(styles_1.StyledModalBody, { className: "ap-modal-body" }, children),
                            footer && (React.createElement(styles_1.StyledModalFooter, { className: "ap-modal-footer" }, footer({
                                handleClose: function () { return handleClose(); },
                            }))))))), document.body)));
};
exports.ApModal.defaultProps = {
    isDismissible: false,
    isFluid: false,
    isOpen: false,
    zIndex: theme_1.depths.modal,
};
//# sourceMappingURL=ApModal.js.map